<template src="./template.html"></template>

<script>
export default {
  name: "PayDataForm",
  props: {
    payway_data: {
      require: true,
      type: Array
    },
    user_data: {
      require: true,
      type: Object
    },
    value: {
      require: true,
      type: Object
    },
    show: {
      require: true,
      type: Boolean
    },
    installment_fee: {
      require: true,
      type: Object
    },
    total_price: {
      require: true,
      type: Number
    }
  },
  data() {
    return {
    }
  },
  methods: {
    ChoosePayWay(item) {
      let tmp = Object.assign({}, this.value)
      tmp.type = item.type
      this.$emit("input", tmp)
    },
    ChooseInstallment(item) {
      let tmp = Object.assign({}, this.value)
      tmp.installment = item
      this.$emit("input", tmp)
    }
  },
}
</script>